












import { BaseInput } from '#components/dms/common/baseInput';
import DmsWrapper from '#components/dms/form/Wrapper.vue';

export default BaseInput.extend({
	name: 'DmsDphCalculator',
	components: { DmsWrapper },
	props: {
		labelKey: { type: String, required: true },
		value: { type: Number },
		dphSazba: { type: Number, default: 0 }, // sazba ne sazba označení
		precision: { type: Number, default: 2 },
		minus: { type: Boolean, default: false },
		span: { type: Number, default: 24 },
		noLabelAlign: { type: Boolean, default: false },
	},
	data() {
		return {
			cenaSDph: 0 as number | null,
			cenaBezDph: 0 as number | null,
		};
	},
	computed: {
		bezDphCmp: {
			get(this: { cenaBezDph: number | null }) {
				return this.cenaBezDph;
			},
			set(val: number | null) {
				this.cenaBezDph = val;
				this.cenaSDph = this.cenaBezDph !== null ? (this.cenaBezDph * (100 + this.dphSazba)) / 100 : null;
				this.$emit('update:value', val);
			},
		},
		vcetneDphCmp: {
			get(this: { cenaSDph: number | null }) {
				return this.cenaSDph;
			},
			set(val: number | null) {
				this.cenaSDph = val;
				this.cenaBezDph = this.cenaSDph !== null ? (100 * this.cenaSDph) / (100 + this.dphSazba) : null;
				this.$emit('update:value', this.cenaBezDph);
			},
		},
	},
	mounted() {
		if (this.bezDphCmp !== this.value) {
			this.bezDphCmp = this.value;
		}
	},
	watch: {
		value() {
			if (this.bezDphCmp !== this.value) {
				this.bezDphCmp = this.value;
			}
		},
	},
});
